"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
export default function NetworkPageLayoutApp(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <main className="tailwind-scope tw-overflow-x-hidden tw-bg-iron-950"><div className="tailwind-scope tw-mx-auto tw-mt-6 tw-bg-iron-950 tw-px-4 tw-pb-6 lg:tw-mt-8 lg:tw-pb-8">{children}</div></main>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}